import React, { useState } from "react";
import './formcontact.css';
import {
  User,
  Mail,
  Phone,
  Building2,
  Globe,
  MessageSquare,
  Send,
} from 'lucide-react';

export default function FormContact(props) {
  const [res, setRes] = useState(undefined);
  const [formData, setFormData] = useState({
    firstname: '',
    secondname: '',
    companyname: '',
    businessemail: '',
    phonenumber: '',
    country: '',
    message: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const backendUrl = 'https://dabler.co.uk/api/contactus';

    try {
      const response = await fetch(backendUrl, {
        method: "POST",
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...formData }),
      });

      if (response.ok) {
        setRes(true);
        hideMsg();
      } else {
        setRes(false);
        hideMsg();
      }
    } catch (err) {
      setRes(false);
      hideMsg();
    }
  };

  const hideMsg = () => {
    setTimeout(() => {
      setRes(undefined);
    }, 8000);
  };

  return (
    <div className="db-form-com-cont" id="contact-us">
      <div className="db-form-com-wrap">
        <div className="db-form-com-head">Contact Us</div>
        <form onSubmit={handleSubmit} className="db-form-com">
          <div className="db-form-com-lab-in icon-wrap">
            <label htmlFor="firstName" className="db-form-com-lab">First Name*</label>
            <User className="db-form-icon" />
            <input
              type="text"
              id="firstName"
              placeholder="First Name"
              className="db-form-com-input"
              name="firstname"
              value={formData.firstname}
              onChange={handleChange}
              required
            />
          </div>

          <div className="db-form-com-lab-in icon-wrap">
            <label htmlFor="lastName" className="db-form-com-lab">Last Name*</label>
            <User className="db-form-icon" />
            <input
              type="text"
              id="lastName"
              placeholder="Last Name"
              className="db-form-com-input"
              name="secondname"
              value={formData.secondname}
              onChange={handleChange}
              required
            />
          </div>

          <div className="db-form-com-lab-in icon-wrap">
            <label htmlFor="companyName" className="db-form-com-lab">Company Name*</label>
            <Building2 className="db-form-icon" />
            <input
              type="text"
              id="companyName"
              placeholder="Company Name"
              className="db-form-com-input"
              name="companyname"
              value={formData.companyname}
              onChange={handleChange}
              required
            />
          </div>

          <div className="db-form-com-lab-in icon-wrap">
            <label htmlFor="email" className="db-form-com-lab">Business Email*</label>
            <Mail className="db-form-icon" />
            <input
              type="email"
              id="email"
              placeholder="Business Email"
              className="db-form-com-input"
              name="businessemail"
              value={formData.businessemail}
              onChange={handleChange}
              required
            />
          </div>

          <div className="db-form-com-lab-in icon-wrap">
            <label htmlFor="phoneNumber" className="db-form-com-lab">Phone Number*</label>
            <Phone className="db-form-icon" />
            <input
              type="tel"
              id="phoneNumber"
              placeholder="Phone Number"
              className="db-form-com-input"
              name="phonenumber"
              value={formData.phonenumber}
              onChange={handleChange}
              required
            />
          </div>

          <div className="db-form-com-lab-in icon-wrap">
            <label htmlFor="country" className="db-form-com-lab">Country*</label>
            <Globe className="db-form-icon" />
            <input
              type="text"
              id="country"
              placeholder="Country"
              className="db-form-com-input"
              name="country"
              value={formData.country}
              onChange={handleChange}
              required
            />
          </div>

          <div className="db-form-com-lab-ta icon-wrap">
            <label htmlFor="message" className="db-form-com-lab">Message*</label>
            <MessageSquare className="db-form-icon textarea-icon" />
            <textarea
              id="message"
              className="db-form-com-ta"
              placeholder="Message"
              name="message"
              value={formData.message}
              onChange={handleChange}
              required
              maxLength={400}
            />
          </div>

          <div className="db-form-com-btn-cont">
            <button type="submit">
              <Send size={18} style={{ marginRight: '6px' }} />
              Send
            </button>
            {res === true ?
              (<div style={{ color: "green" }} className="rmsg">We got your message. We'll reach out shortly!</div>) :
              res === false ?
                (<div style={{ color: "red" }} className="rmsg">Couldn't send your request, please try again!</div>) :
                (<div style={{ color: 'transparent' }} className="rmsg">.</div>)
            }
          </div>
        </form>
      </div>
    </div>
  );
}
